import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { SSO_KEYS } from "Payments/FundItPage/API";

import FnrButton from "UI/FnrButton3";
import { colors } from "UI/colors";

MoreSetupNeeded.propType = {
  progress: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};

export default function MoreSetupNeeded({ progress, settings }) {
  const { description, buttonText } = getActionContent(progress);

  const isWaitingForKYCApproval = progress.state === "waitingForKYCApproval";
  const awaitingReactivation = progress.state === "awaitingReactivation";

  const userCanAccessWePayMerchantCenter =
    progress?.fundItStatusData?.userCanAccessWePayMerchantCenter;

  return (
    <Wrapper>
      <Content>
        {isWaitingForKYCApproval || awaitingReactivation ? null : (
          <ActionNeeded>
            <span className="fas fa-exclamation-triangle" /> Action Needed
          </ActionNeeded>
        )}
        <Description>{description}</Description>
      </Content>

      {awaitingReactivation ? null : (
        <ButtonWrapper>
          <FnrButton
            onClick={() => window.fnReactBus.goToUrl("/fundit")}
            color={colors.fnDkBlue}
            size="large"
          >
            View Setup Steps
          </FnrButton>

          {isWaitingForKYCApproval ||
          !userCanAccessWePayMerchantCenter ? null : (
            <Btn2Wrapper>
              <FnrButton
                onClick={() =>
                  window.open(
                    `/fundit/merchantcenter?ssoKey=${SSO_KEYS.initiateWePaySSO}`
                  )
                }
                color={colors.fnYellow}
                size="large"
              >
                {buttonText}
              </FnrButton>
              <BtnSubtext>So you can access funds ASAP!</BtnSubtext>
            </Btn2Wrapper>
          )}
        </ButtonWrapper>
      )}
    </Wrapper>
  );
}

const getActionContent = (progress) => {
  switch (progress?.state) {
    case "needToEnterKYC":
      return {
        description: "Enter your bank deposit information",
        buttonText: "Action Needed",
      };
    case "needToEnterBankInfo":
      return {
        description:
          "Visit the WePay Merchant Center to fill out missing bank information",
        buttonText: "Action Needed",
      };
    case "hasKYCValidationError":
      return {
        description:
          "Your deposit information could not be validated. Please update.",
        buttonText: "Action Needed",
      };
    case "waitingForKYCApproval":
      return {
        description: "Your deposit information is undergoing validation",
      };
    case "awaitingReactivation":
      return {
        description:
          "We are in the process of reactivating your Fund It account. Our Happiness Engineers will be reaching out, or you can contact help@flocknote.com.",
      };
    default:
      return {
        description: "Enter your bank deposit information",
        buttonText: "Action Needed",
      };
  }
};

const Wrapper = styled.div`
  margin-top: 5px;
`;

const Content = styled.div`
  text-align: center;
  color: ${colors.fnDkBlue};
`;

const ActionNeeded = styled.div`
  font-weight: 600;
  font-size: 24px;

  span {
    color: ${colors.fnYellow};
  }
`;

const Description = styled.div`
  font-size: 17px;
  margin-top: 5px;
  font-weight: 400;
`;

const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
`;

const Btn2Wrapper = styled.div`
  margin-left: auto;
`;

const BtnSubtext = styled.div`
  margin-top: 5px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
`;
